import languages from '../assets/languages.json';

function navigateByString(str) {
  try{
    let a = str.split(".");
    const language = getLanguage();
    let val = languages[language];
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (k in val) {
        val = val[k];
      } else {
        return str;
      }
    }
    return val;
  } catch (e) {
    return str;
  }
}

function mapLanguage(language) {
  switch (language) {
    case 'en':
    case 'GB':
      return 'en';
    default:
      return 'lt';
  }
}

export function setLanguage(language) {
  window.sessionStorage.setItem('language', mapLanguage(language));
}

export function getLanguage() {
  const language = window.sessionStorage.getItem('language') || mapLanguage(getLanguageFromUrl()) || 'lt';
  return language;
}

export function getLanguageFromUrl() {
  const url = window.location.pathname;
  const match = url.match(/\/listing\/(.{2})\//);
  if(match) {
    return match[1];
  }
  return 'lt';
}

export function getReverseLanguage(code) {
  switch (code) {
    case 'LT':
    case 'lt':
      return 'LT';
    case 'GB':
    case 'en':
      return 'GB';
    default:
  }
}

export function translate(key) {
  if (!key) return;
  if(Array.isArray(key)) return key.map(k => navigateByString(k) ).join(', ');
  return navigateByString(key);
}

export function toSlug(str) {
  str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  str = str.toLowerCase();
  str = str.replace(/[^a-z0-9\s-]/g, '');
  str = str.replace(/\s+/g, '-');
  return str;
}

export function toEstateSlug(estate){
  return toSlug(translate(estate.operation + '.' + estate.estate_type) + ', ' + estate.location?.formated_address);
}

export function generateEstateUrl (lang, key, estate){
  return `/listing/${lang}/${key}/${estate.token}/${toEstateSlug(estate)}`;
}

